module.exports = __webpack_public_path__ + "img/4-01.6bc88755.png";